import d from "./DOM.js";

export default class Simulator {
	public static init() {
		const btn = d.qs('#run-simulation');
		if (btn) {
			d.e('click', () => Simulator.run(), btn);
			// Initial run
			Simulator.run();
		}
	}

	public static run() {
		const startBalance = parseFloat(d.qs<HTMLInputElement>('#sim-start-balance').value) || 10000;
		const tradeCount = parseInt(d.qs<HTMLInputElement>('#sim-trade-count').value) || 100;
		const winRate = parseFloat(d.qs<HTMLInputElement>('#sim-win-rate').value) / 100 || 0.5;
		const riskPercent = parseFloat(d.qs<HTMLInputElement>('#sim-risk-percent').value) / 100 || 0.01;
		const rewardRatio = parseFloat(d.qs<HTMLInputElement>('#sim-reward-ratio').value) || 2;

		let currentBalance = startBalance;
		const history = [startBalance];
		let peak = startBalance;
		let maxDD = 0;

		for (let i = 0; i < tradeCount; i++) {
			const isWin = Math.random() < winRate;
			const riskAmount = currentBalance * riskPercent;

			if (isWin) {
				currentBalance += riskAmount * rewardRatio;
			} else {
				currentBalance -= riskAmount;
			}

			history.push(currentBalance);

			if (currentBalance > peak) {
				peak = currentBalance;
			}

			const dd = (peak - currentBalance) / peak;
			if (dd > maxDD) {
				maxDD = dd;
			}
		}

		// Update UI
		d.qs('#sim-res-final').innerText = `$${currentBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
		d.qs('#sim-res-dd').innerText = `${(maxDD * 100).toFixed(2)}%`;
		const profit = currentBalance - startBalance;
		d.qs('#sim-res-profit').innerText = `${profit >= 0 ? '+' : ''}$${profit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
		d.qs('#sim-res-profit').style.color = profit >= 0 ? 'var(--theme-status-profit)' : 'var(--theme-status-loss)';

		Simulator.drawChart(history);
	}

	private static drawChart(history: number[]) {
		const canvas = d.qs<HTMLCanvasElement>('#equityChart');
		if (!canvas) return;

		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		// Clear
		ctx.clearRect(0, 0, canvas.width, canvas.height);

		const padding = 20;
		const w = canvas.width - padding * 2;
		const h = canvas.height - padding * 2;

		const min = Math.min(...history);
		const max = Math.max(...history);
		const range = max - min || 1;

		ctx.beginPath();
		ctx.strokeStyle = '#3b82f6';
		ctx.lineWidth = 2;

		history.forEach((val, i) => {
			const x = padding + (i / (history.length - 1)) * w;
			const y = padding + h - ((val - min) / range) * h;

			if (i === 0) ctx.moveTo(x, y);
			else ctx.lineTo(x, y);
		});

		ctx.stroke();

		// Draw baseline (start balance)
		const startVal = history[0];
		const baseY = padding + h - ((startVal - min) / range) * h;
		ctx.setLineDash([5, 5]);
		ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
		ctx.beginPath();
		ctx.moveTo(padding, baseY);
		ctx.lineTo(padding + w, baseY);
		ctx.stroke();
		ctx.setLineDash([]);
	}
}
